export default __webpack_public_path__ + "static/media/deviantart.127c0f2a.png";